import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  freightOn: null,
  freightContainerCapacity: {
    road: null,
    ocean: null,
  },
}

export const freightTypeSlice = createSlice({
  name: 'freightType',
  initialState,
  reducers: {
    setFreightOn: (state, action) => {
      state.freightOn = action.payload
    },
    setFreightContainerCapacity: (state, action) => {
      state.freightContainerCapacity = action.payload
    },
  },
})
export const { setFreightOn, setFreightContainerCapacity } = freightTypeSlice.actions
export default freightTypeSlice.reducer
